// Five practice areas of the firm.

export const PRACTICE_AREAS = [
  {
    slug: "business-transactions",
    number: "01",
    name: "Business Transactions",
    kicker: "Counsel for closely-held companies, founders, and operating businesses.",
    lead:
      "The firm advises companies and their owners across the transactions that shape a business — formation, financing, contracts, ownership changes, and exits. Engagements range from a single negotiated agreement to ongoing outside general counsel for operating companies.",
    sections: [
      {
        h: "Formation and Governance",
        p: "Entity selection and formation in Tennessee, Delaware, and other states; operating agreements, shareholder agreements, partnership agreements; voting and ownership structures; board and committee arrangements; and the governance documents that determine how a company actually runs.",
      },
      {
        h: "Commercial Agreements",
        p: "Customer and vendor contracts; master services agreements and statements of work; licensing, distribution, and reseller agreements; supply and procurement; software-as-a-service and technology agreements; confidentiality and intellectual property assignments.",
      },
      {
        h: "Equity and Financing",
        p: "Founder equity arrangements, vesting, and 83(b) elections; capitalization tables; private placements under Regulation D (Rule 506(b) and 506(c)), Regulation A, Regulation CF, intrastate exemptions, and Section 4(a)(2); convertible instruments and SAFEs; debt and senior-secured financings; investor side letters.",
      },
      {
        h: "M&A and Exits",
        p: "Stock and asset sales, mergers, divisional carve-outs, recapitalizations, and ownership transitions. Letter-of-intent negotiation, due diligence (sell-side and buy-side), definitive documentation, escrow and earn-out structures, and closing.",
      },
    ],
  },
  {
    slug: "international-trade",
    number: "02",
    name: "International Trade",
    kicker: "Counsel for companies whose business does not stop at the border.",
    lead:
      "The firm advises domestic and international clients on cross-border transactions, customs and import matters, sanctions, and the regulatory architecture of moving goods, services, and technology across jurisdictions.",
    sections: [
      {
        h: "Cross-Border Transactions",
        p: "International distribution and supply arrangements, agency and representation agreements, joint ventures, manufacturing and toll-processing arrangements, and the contractual structures that govern multi-jurisdictional commercial relationships.",
      },
      {
        h: "Customs and Import",
        p: "Tariff classification, valuation, country-of-origin determinations, free trade agreement qualification, marking and labeling, drawback, prior disclosures, and protests before U.S. Customs and Border Protection.",
      },
      {
        h: "Sanctions and OFAC",
        p: "Country-based and list-based sanctions programs administered by the U.S. Department of the Treasury's Office of Foreign Assets Control; counterparty screening; license applications; voluntary self-disclosures; and operational compliance structures.",
      },
      {
        h: "Maritime and Defense Industries",
        p: "The firm draws on substantial experience representing clients in the maritime, defense, and commercial space industries, including matters involving charterparty agreements, piracy, defense contracting, and the legal architecture of commercial space activity.",
      },
    ],
  },
  {
    slug: "export-compliance",
    number: "03",
    name: "Export Compliance",
    kicker: "ITAR, EAR, and the regulatory regime governing controlled technology.",
    lead:
      "Companies that develop, manufacture, or transfer controlled technology — including dual-use products, defense articles, software, and technical data — operate under one of the most consequential regulatory regimes in U.S. law. The firm advises clients across jurisdiction, classification, licensing, and program design.",
    sections: [
      {
        h: "Jurisdiction and Classification",
        p: "Determination of whether items are subject to the International Traffic in Arms Regulations (ITAR), the Export Administration Regulations (EAR), or another regime; commodity jurisdiction requests; classification (USML categories and Export Control Classification Numbers); and commodity classification (CCATS) requests.",
      },
      {
        h: "Licensing and Authorization",
        p: "License applications and use of license exceptions under the EAR; ITAR licenses (DSP-5, DSP-73, DSP-85, and related authorizations); technical assistance and manufacturing license agreements; agreements involving foreign-person employees and deemed exports.",
      },
      {
        h: "Compliance Programs and Training",
        p: "Design and implementation of export compliance programs tailored to the company's products, customers, and footprint; technology control plans; recordkeeping; and personnel training. Counsel draws on direct teaching experience with the Export Compliance Training Institute.",
      },
      {
        h: "Voluntary Disclosures and Enforcement",
        p: "Investigation of potential violations, voluntary self-disclosures to the U.S. State Department's Directorate of Defense Trade Controls and the U.S. Department of Commerce's Bureau of Industry and Security, and representation in administrative enforcement matters.",
      },
    ],
  },
  {
    slug: "cfius",
    number: "04",
    name: "CFIUS",
    kicker: "Foreign investment review, mitigation, and notice strategy.",
    lead:
      "The Committee on Foreign Investment in the United States (CFIUS) reviews transactions in which a foreign person could acquire control of, or certain non-controlling interests in, U.S. businesses — particularly in critical technology, critical infrastructure, and sensitive personal data. The firm represents both U.S. sellers and foreign investors throughout the CFIUS process.",
    sections: [
      {
        h: "Pre-Transaction Analysis",
        p: "Assessment of whether a contemplated transaction is a covered transaction, a covered control transaction, a covered investment, or a covered real estate transaction; analysis of mandatory versus voluntary filing pathways; and structuring options to manage CFIUS exposure.",
      },
      {
        h: "Declarations and Notices",
        p: "Preparation and filing of CFIUS declarations and full joint voluntary notices; coordination with the Department of the Treasury and the CFIUS member agencies; responses to questions; and management of the statutory review and investigation timeline.",
      },
      {
        h: "Mitigation",
        p: "Negotiation of mitigation measures, national security agreements, and operational commitments; appointment of monitors and security officers; and ongoing compliance with mitigation requirements.",
      },
      {
        h: "Post-Closing Compliance and Enforcement",
        p: "Ongoing CFIUS mitigation compliance, periodic reporting, non-notified transaction inquiries, and representation in CFIUS enforcement matters.",
      },
    ],
  },
  {
    slug: "foci",
    number: "05",
    name: "FOCI",
    kicker: "Foreign ownership, control, or influence — mitigation, facility clearances, and DCSA compliance.",
    lead:
      "Companies pursuing or holding a facility clearance (FCL) — and their foreign investors — face a distinct regulatory regime administered by the Defense Counterintelligence and Security Agency (DCSA) under the National Industrial Security Program Operating Manual (NISPOM, 32 CFR Part 117). The firm advises U.S. cleared contractors, foreign investors, and defense-adjacent companies on FOCI assessment, mitigation instrument selection, and ongoing NISPOM compliance.",
    sections: [
      {
        h: "FOCI Assessment and Disclosure",
        p: "Analysis of whether a company is under foreign ownership, control, or influence — including aggregation of foreign interests, review of governance rights, debt terms, and material relationships; preparation and updating of the SF-328 (Certificate Pertaining to Foreign Interests); and coordination of disclosures with DCSA during initial and continuing FCL processing.",
      },
      {
        h: "Mitigation Instruments",
        p: "Selection and negotiation of FOCI mitigation instruments — Board Resolutions, Security Control Agreements (SCA), Special Security Agreements (SSA), Voting Trust Agreements, and Proxy Agreements; drafting of Electronic Communications Plans, Technology Control Plans, and Affiliated Operations Plans; and coordination with U.S. Government Contracting Activities on program-specific mitigation.",
      },
      {
        h: "Facility Clearance and KMP Eligibility",
        p: "Facility clearance sponsorship and processing; Key Management Personnel (KMP) determinations; integration of FOCI mitigation with personnel security clearances; classified contract flow-down analysis; and coordination between DCSA, DoD, DoE, and non-DoD Cognizant Security Agencies.",
      },
      {
        h: "Ongoing NISPOM Compliance and Changed Conditions",
        p: "Annual FOCI certifications, changed-condition reporting, insider threat program requirements, and periodic mitigation-agreement reviews; coordination of Government Security Committees under SSAs and SCAs; and response to DCSA industrial security oversight and enforcement matters.",
      },
    ],
  },
  {
    slug: "government-contracts",
    number: "06",
    name: "Government Contracts",
    kicker: "Federal contracting counsel for innovation companies, small businesses, and defense-adjacent contractors.",
    lead:
      "The firm advises companies on federal contracting matters, with particular emphasis on innovation and technology programs — SBIR/STTR awards, Cooperative Research and Development Agreements (CRADAs), Other Transaction Authority (OTA) agreements — and the compliance obligations that come with doing business with the U.S. government.",
    sections: [
      {
        h: "SBIR and STTR Awards",
        p: "Small Business Innovation Research (SBIR) and Small Business Technology Transfer (STTR) proposals, awards, and administration across Phase I, Phase II, and Phase III. Small-business eligibility (including ownership and affiliation analysis under 13 C.F.R. § 121), foreign-ownership and foreign-investor issues, data rights (SBIR/STTR Data Rights and government purpose rights), and Phase III commercialization strategy.",
      },
      {
        h: "CRADAs and Federal Research Partnerships",
        p: "Cooperative Research and Development Agreements with federal laboratories and agencies under the Federal Technology Transfer Act; work-for-others agreements; patent license agreements; and coordination between CRADA arrangements and adjacent SBIR/STTR or OTA activity. The firm has particular experience with defense and commercial-space partnerships.",
      },
      {
        h: "Prime Contracts, Subcontracts, and OTAs",
        p: "Prime and subcontract negotiation under the Federal Acquisition Regulation (FAR) and Defense FAR Supplement (DFARS); teaming and non-disclosure agreements; Other Transaction Authority (OTA) agreements administered by DoD and NASA; consortia participation; and flow-down analysis in complex subcontract structures.",
      },
      {
        h: "Compliance, Data Rights, and Disputes",
        p: "Cost accounting and allowability, small business set-aside and size-protest matters, Bayh-Dole compliance and technical data rights, cybersecurity and CMMC obligations, mandatory disclosures, terminations, requests for equitable adjustment, and pre-award and post-award bid protests before the GAO and the Court of Federal Claims.",
      },
      {
        h: "Facility Clearance and FOCI Mitigation",
        p: "Support for contractors that hold or are seeking a Facility Security Clearance (FCL) under the National Industrial Security Program — sponsorship, DD-441 processing, key management personnel clearances, and the industrial security controls required to receive and safeguard classified information. Where a company is under foreign ownership, control, or influence, the firm structures and negotiates FOCI mitigation instruments (SSAs, SCAs, Proxy Agreements, Board Resolutions) with DCSA. See the firm's dedicated FOCI Mitigation practice area for full detail.",
      },
    ],
  },
  {
    slug: "intellectual-property",
    number: "07",
    name: "Intellectual Property",
    kicker: "Counsel for the creation, protection, and licensing of intangible assets.",
    lead:
      "The firm advises companies on the identification, protection, and commercialization of intellectual property — patents, trademarks, copyrights, trade secrets, and licensed technology. Engagements range from establishing a first IP program at a young company to negotiating complex licensing arrangements for mature operating businesses.",
    sections: [
      {
        h: "Patents",
        p: "Patent strategy and portfolio management; coordination of prosecution with patent counsel; freedom-to-operate analysis; inventor assignments and prior-art considerations; and the enforcement and licensing decisions that follow issuance.",
      },
      {
        h: "Trademarks and Copyrights",
        p: "Brand clearance, U.S. and international trademark registration and prosecution, use and enforcement policies, licensing, oppositions and cancellations before the Trademark Trial and Appeal Board, and copyright registration and enforcement.",
      },
      {
        h: "Trade Secrets",
        p: "Identification and classification of trade-secret assets, reasonable-measures programs, confidentiality and IP assignment agreements with employees and contractors, and enforcement under the federal Defend Trade Secrets Act and the Tennessee Uniform Trade Secrets Act.",
      },
      {
        h: "Technology and Open Source Licensing",
        p: "Inbound and outbound technology, patent, and software licenses; cross-licensing; open source license inventory and compliance programs (permissive and copyleft); contributor license agreements; and the license diligence that precedes any material technology transaction.",
      },
    ],
  },
  {
    slug: "artificial-intelligence",
    number: "07",
    name: "Artificial Intelligence",
    hidden: true,
    kicker: "Legal counsel for companies building, deploying, and governing AI systems.",
    lead:
      "The firm advises companies on the legal architecture of artificial intelligence — from training-data licensing and model IP through algorithmic accountability, data privacy, and the emerging regulatory frameworks that govern high-impact automated systems.",
    sections: [
      {
        h: "Model Development and Training Data",
        p: "Sourcing and licensing of training data; contractual allocation of rights in models, weights, and outputs; ownership and inventorship questions; and the intellectual property strategy that supports a defensible AI product.",
      },
      {
        h: "Algorithmic Accountability",
        p: "Governance frameworks aligned with the NIST AI Risk Management Framework and comparable standards; documentation and evaluation protocols; bias and fairness assessments; and the interplay with sector-specific rules under the CFPB, EEOC, and state algorithmic-decision laws.",
      },
      {
        h: "Data Privacy and Governance",
        p: "CCPA/CPRA and the growing patchwork of state comprehensive privacy laws; GDPR interfaces for U.S. companies serving European users; privacy impact assessments; vendor and processor arrangements; and the notice, retention, and rights-request programs that accompany them.",
      },
      {
        h: "Deployment, Product Terms, and Enterprise Contracts",
        p: "Customer-facing terms for AI-enabled products; representations, disclaimers, and use restrictions; acceptable-use and safety policies; and enterprise contracts covering data usage, indemnification, and evolving compliance obligations.",
      },
    ],
  },
  {
    slug: "semiconductor-industry",
    number: "08",
    name: "Semiconductor Industry",
    hidden: true,
    kicker: "Regulatory and transactional counsel for the semiconductor ecosystem.",
    lead:
      "The firm advises semiconductor companies, materials suppliers, equipment manufacturers, and downstream users on the regulatory regimes that increasingly define the sector — CHIPS Act compliance, export controls, and the supply-chain security requirements at the center of U.S. industrial policy.",
    sections: [
      {
        h: "CHIPS Act Compliance",
        p: "Requirements attaching to CHIPS Incentives funding and the Advanced Manufacturing Investment Credit; national-security-related guardrails on foreign entities of concern; expansion, joint venture, and technology-transfer restrictions; and reporting and audit obligations.",
      },
      {
        h: "Export Controls on Semiconductor Technology",
        p: "Advanced-node and advanced-computing controls under the Export Administration Regulations; the Foreign Direct Product Rule; Entity List and foreign-produced items considerations; deemed exports; and license and license-exception analysis specific to semiconductor design, manufacturing, and equipment.",
      },
      {
        h: "Supply Chain Security",
        p: "Information and Communications Technology and Services (ICTS) review; Section 889 compliance; country-of-origin and rules-of-origin analysis; supplier vetting; and the cybersecurity and audit requirements that increasingly attach to critical technology supply chains.",
      },
      {
        h: "Transactional and Investment Matters",
        p: "CFIUS filings and mitigation involving semiconductor businesses; joint ventures and technology licensing arrangements across borders; and coordination of regulatory and transactional workstreams in M&A involving fabless designers, foundries, materials, and equipment suppliers.",
      },
    ],
  },
  {
    slug: "fcc",
    number: "08",
    name: "FCC",
    kicker: "Communications and spectrum counsel across satellite, wireless, and terrestrial services.",
    lead:
      "The firm advises companies whose operations touch the Federal Communications Commission — including satellite operators, earth stations, wireless service providers, IoT device manufacturers, and terrestrial communications businesses. Engagements range from licensing and equipment authorization through transactional filings and enforcement responses.",
    sections: [
      {
        h: "Satellite and Space-Based Licensing",
        p: "Part 25 space station authorizations for geostationary and non-geostationary systems; market access grants for foreign-licensed satellites; earth station licensing and blanket authorizations; spectrum coordination and interference analysis; and coordination with adjacent regulatory bodies including NOAA (remote sensing) and the FAA.",
      },
      {
        h: "Equipment Authorization and Certification",
        p: "Certification, Supplier's Declaration of Conformity (SDoC), and other authorization pathways under Parts 2, 15, and 18; RF exposure and technical compliance; labeling; and coordination with FCC-recognized Telecommunications Certification Bodies (TCBs) and test laboratories.",
      },
      {
        h: "Wireless, Spectrum, and Terrestrial Services",
        p: "Licensed and unlicensed wireless services under Parts 22, 24, 27, and 90; spectrum leasing and secondary market transactions; tower siting and structural notifications; private wireless network deployments; and spectrum policy matters before the Commission and industry bodies.",
      },
      {
        h: "Transactions, Team Telecom, and Enforcement",
        p: "Section 214 authorizations for domestic and international common carriers; transfer-of-control and pro forma filings; coordination with the Committee for the Assessment of Foreign Participation in the U.S. Telecommunications Services Sector (Team Telecom); responses to Enforcement Bureau inquiries and Letters of Inquiry; and consent decree negotiation.",
      },
    ],
  },
  {
    slug: "insurance",
    number: "09",
    name: "Insurance",
    kicker: "Coverage counsel and risk-management strategy for operating businesses.",
    lead:
      "The firm advises businesses on insurance placement, coverage disputes, and the design of risk-management programs that align with actual operational exposure. The practice emphasizes lines of coverage most relevant to operating companies and technology businesses.",
    sections: [
      {
        h: "Products Liability",
        p: "Products liability coverage placement, tender and defense of claims, coordination between primary and excess carriers, indemnity structures in the supply chain, additional-insured and contractual-liability endorsements, and subrogation.",
      },
      {
        h: "Cyber Liability and Data Breach",
        p: "Cyber policy analysis and placement; coordination of breach counsel, forensics, and notification vendors under the policy; retention and sublimit structures; ransomware and business-interruption coverage; and post-loss coverage disputes.",
      },
      {
        h: "Commercial General Liability and Related Lines",
        p: "CGL, umbrella and excess placement; property and business interruption; employment practices liability; directors and officers liability; and the endorsements that determine whether a policy actually responds to the business's exposure.",
      },
      {
        h: "Coverage Disputes",
        p: "Pre-litigation coverage analysis, tender and reservation-of-rights responses, coverage litigation and appraisal, mediation, and bad-faith claims where appropriate.",
      },
    ],
  },
  {
    slug: "estate-planning",
    number: "11",
    name: "Estate Planning",
    hidden: true,
    kicker: "A select practice in coordinated estate and trust planning.",
    lead:
      "The firm maintains a small estate planning practice for clients whose work it already represents, focused on situations in which closely-held business interests, real property, or other complex assets call for coordinated planning. Engagements are taken on a selective basis.",
    sections: [
      {
        h: "Trusts",
        p: "Revocable living trusts as the foundation of the plan; irrevocable trusts for tax and asset-protection objectives; Tennessee dynasty trusts (up to 360 years); and other long-term trust structures where appropriate.",
      },
      {
        h: "Ancillary and Incapacity Documents",
        p: "Wills coordinated with the trust; durable financial powers of attorney; healthcare powers of attorney and advance directives; HIPAA authorizations.",
      },
      {
        h: "Coordination with Business and Real Property Interests",
        p: "Integration of the estate plan with the company's governance documents, buy-sell arrangements, and ownership structures; planning for operating real estate.",
      },
      {
        h: "Trust Administration",
        p: "Representation of successor trustees in trust funding and post-death administration when matters arise within existing client relationships.",
      },
    ],
  },
];

export function getPracticeArea(slug) {
  return PRACTICE_AREAS.find((p) => p.slug === slug && !p.hidden);
}

export const VISIBLE_PRACTICE_AREAS = PRACTICE_AREAS.filter((p) => !p.hidden);
